// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__WX4Cd","emails":"CreateEditClinics_emails__3f0hi","emailTagLabel":"CreateEditClinics_emailTagLabel__qWxzj"};